// import "@carbon/web-components/es/components/multi-select/index.js";
// import "@carbon/web-components/es/components/date-picker/index.js";

import Listing from "./components/Listing";
import { format, isWithinInterval } from "date-fns";
import flatpickr from "flatpickr";
import { throttle, debounce } from "./utils/Performance";
import "flatpickr/dist/flatpickr.css";

export const whatsOnListing = async (element) => {
    if (element) {
        // View mode, toggle elements based on [data-show] and [data-hide]
        const view_mode = document.querySelectorAll("#view-mode .btn");
        const listing_heading = document.getElementById("whats-on-heading");

        // Filters status bar
        const status_bar_event = document.querySelector(
            "[data-status-message].by-event",
        );

        // const no_results = document.querySelector("#noResultsSection");
        const events_by_date = document.getElementById("whats-on-by-date");

        // Featured blocks
        const featured_events = document.getElementById("featured-events");
        const featured_programmes = document.getElementById(
            "featured-programmes",
        );

        var listing_is_filtered = false;
        var selected_dates = [];

        // Reset filters button
        const reset_button = document.createElement("button");
        reset_button.name = "reset";
        reset_button.classList.add("btn--pill");
        reset_button.textContent = "Reset filters";

        // View mode selectors
        const view_by_event = document.getElementById("by-event");
        const view_by_date = document.getElementById("by-date");

        // Search
        const search_keyword = document.getElementById("search-events");
        const search_button = document.getElementById("search-all-events");
        function search_results(keyword) {
            let query = `/?s=${keyword}`;
            location.href = query;
        }
        search_keyword.addEventListener("keyup", (e) => {
            if (e.key == "Enter" && search_keyword.value != "") {
                search_results(search_keyword.value);
            }
        });
        search_button.addEventListener("click", (e) => {
            if (search_keyword.value != "") {
                search_results(search_keyword.value);
            }
        });

        // Mobile date picker
        const picker = document.querySelector("#date-picker");
        const calendar_picker = () => {
            flatpickr(picker, {
                inline: true,
                mode: "range",
                minDate: "today",
                monthSelectorType: "static",
                locale: {
                    firstDayOfWeek: 1,
                },
                prevArrow:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M9.53082 15.5567C8.90525 16.1478 7.89099 16.1478 7.26542 15.5567L0.469225 9.13561C-0.156347 8.54457 -0.156347 7.5863 0.469225 6.99525C1.0948 6.4042 2.10905 6.4042 2.73462 6.99525L9.53082 13.4163C10.1564 14.0074 10.1564 14.9657 9.53082 15.5567Z" fill="black"/><path d="M9.53077 0.443284C10.1563 1.03433 10.1563 1.9926 9.53077 2.58365L2.73458 9.00475C2.109 9.5958 1.09475 9.5958 0.469179 9.00475C-0.156395 8.41371 -0.156395 7.45543 0.469178 6.86438L7.26537 0.443285C7.89095 -0.147761 8.9052 -0.147761 9.53077 0.443284Z" fill="black"/></svg>',
                nextArrow:
                    '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none"><path d="M0.469179 15.5567C1.09475 16.1478 2.10901 16.1478 2.73458 15.5567L9.53077 9.13561C10.1563 8.54457 10.1563 7.5863 9.53077 6.99525C8.9052 6.4042 7.89095 6.4042 7.26538 6.99525L0.469179 13.4163C-0.156394 14.0074 -0.156394 14.9657 0.469179 15.5567Z" fill="black"/><path d="M0.469226 0.443284C-0.156347 1.03433 -0.156347 1.9926 0.469226 2.58365L7.26542 9.00475C7.891 9.5958 8.90525 9.5958 9.53082 9.00475C10.1564 8.41371 10.1564 7.45543 9.53082 6.86438L2.73463 0.443285C2.10905 -0.147761 1.0948 -0.147761 0.469226 0.443284Z" fill="black"/></svg>',
                onChange: function (selectedDates, dateStr, instance) {
                    if (picker?.value) {
                        let dates = picker.value.split(" to ");
                        instances_by_date(dates);
                    }
                },
            });
        };

        // Move search fieldset according to viewport size
        if (window.matchMedia("(max-width: 75em)").matches && picker) {
            calendar_picker();
        }

        // Setup resize events
        window.onresize = debounce((e) => {
            if (window.matchMedia("(max-width: 75em)").matches) {
                if (!picker.classList.contains("flatpickr-input")) {
                    calendar_picker();
                }
            }
        }, 250);

        // Switch view mode, by-event/by-date
        if (view_mode) {
            [...view_mode].forEach((button) => {
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    if (e.currentTarget.classList.contains("active")) {
                        return false;
                    }
                    e.currentTarget.classList.add("active");

                    let show = document.querySelectorAll(
                        e.currentTarget.dataset.show,
                    );
                    show.forEach((item) => {
                        item.setAttribute("aria-hidden", "false");
                    });
                    let hide = document.querySelectorAll(
                        e.currentTarget.dataset.hide,
                    );
                    hide.forEach((item) => {
                        item.setAttribute("aria-hidden", "true");
                    });

                    if (button.href.match("#date")) {
                        document
                            .getElementById("whats-on-filters")
                            .classList.add("view-by-date");
                        document
                            .getElementById("whats-on-filters")
                            .classList.remove("view-by-event");

                        view_by_event.classList.remove("active");
                        document.getElementById("all").checked = true;
                        document
                            .getElementById("all")
                            .dispatchEvent(
                                new Event("change", { bubbles: true }),
                            );

                        // Activate first available day
                        let active_days = document.querySelectorAll(
                            "#events-calendar-months [data-date].active",
                        );

                        if (!active_days.length) {
                            let first_available_day = document.querySelector(
                                "#events-calendar-months [data-date]:not([disabled])",
                            );
                            first_available_day.classList.add("active");
                            setTimeout(() => {
                                first_available_day.dispatchEvent(
                                    new Event("click"),
                                );
                            }, 100);
                        } else {
                            // If there are already active days, only update selected_dates if it's empty
                            if (selected_dates.length === 0) {
                                selected_dates = [
                                    [...active_days].shift(),
                                    [...active_days].pop(),
                                ];
                                selected_dates = selected_dates.map((item) => {
                                    return item.dataset.date;
                                });
                                selected_dates.sort();
                            }
                        }
                    } else if (button.href.match("#event")) {
                        document
                            .getElementById("whats-on-filters")
                            .classList.remove("view-by-date");
                        document
                            .getElementById("whats-on-filters")
                            .classList.add("view-by-event");

                        view_by_date.classList.remove("active");
                        view_by_event.checked = true;

                        if (listing_is_filtered) {
                            document
                                .querySelector("#toggle-more-filters")
                                .dispatchEvent(
                                    new Event("click", { bubbles: true }),
                                );
                        }

                        // document.getElementById("shows").checked = true;
                    }

                    toggle_featured_blocks();
                });
            });
        }

        // Initialise Listing component
        let listing = new Listing({
            root: element,
            listing: "whats-on",
            daterange: "dates",
            pagination: {
                el: ".pagination",
                per_page: 18,
            },
            html: "/wp-content/uploads/whats-on.html",
            json: "/wp-content/uploads/whats-on.json",
            callback: () => {
                //console.log("Status", listing.filters_status);
                filters_status(listing.filters_status);
            },
        });

        const toggle_featured_blocks = () => {
            if (view_by_date.classList.contains("active")) {
                return;
            }
            let current_type = document.querySelector('[name="type"]:checked');

            const genreField = document.querySelector(".form-field.genre");
            const strandField = document.querySelector(".form-field.strand");

            if (listing_is_filtered) {
                featured_events?.setAttribute("aria-hidden", true);
                featured_programmes?.setAttribute("aria-hidden", true);
            } else {
                if (current_type.value == "programme") {
                    featured_events?.setAttribute("aria-hidden", true);
                    featured_programmes?.setAttribute("aria-hidden", false);
                    genreField?.classList.add("hide");
                    strandField?.classList.remove("hide");
                } else if (current_type.value) {
                    featured_events?.setAttribute("aria-hidden", false);
                    featured_programmes?.setAttribute("aria-hidden", true);
                    genreField?.classList.remove("hide");
                    strandField?.classList.add("hide");
                } else {
                    featured_events?.setAttribute("aria-hidden", true);
                    featured_programmes?.setAttribute("aria-hidden", true);
                    genreField?.classList.remove("hide");
                    strandField?.classList.add("hide");
                }
            }
        };

        const toggle_heading_text = (filters) => {
            if (!filters) {
                let current_type = document.querySelector(
                    '[name="type"]:checked',
                );
                if (!current_type.value) {
                    listing_heading.textContent = "All shows and activities";
                } else {
                    listing_heading.textContent =
                        current_type.value == "programme"
                            ? "All activities"
                            : "All shows";
                }
            } else {
                let filtered = Object.keys(filters);

                // Listing heading
                if (!filtered.includes("type")) {
                    listing_heading.textContent =
                        filtered.length > 0
                            ? "Shows and activities filtered by"
                            : "All shows and activities";
                } else if (filters.type.includes("programme")) {
                    listing_heading.textContent =
                        filtered.length > 1
                            ? "Activities filtered by"
                            : "All activities";
                } else {
                    listing_heading.textContent =
                        filtered.length > 1 ? "Shows filtered by" : "All shows";
                }
            }
        };

        // Toggle relevant post types and highlights
        const types = document.querySelectorAll('[name="type"]');
        [...types].forEach((item) => {
            item.addEventListener("change", (e) => {
                toggle_featured_blocks();

                let current_view_mode =
                    document.querySelector("#view-mode .active");

                if (
                    current_view_mode &&
                    current_view_mode.href.match("#date")
                ) {
                    if (selected_dates.length > 0) {
                        instances_by_date(selected_dates);
                    }
                }
            });
        });

        // Client-side date grouping and rendering using pre-cached data
        function instances_by_date(selected_dates) {
            listing.loading_indicator.setAttribute("active", true);

            const startDate = selected_dates[0];
            const endDate = selected_dates[1] || selected_dates[0];

            // Get current event type filter
            const currentType =
                listing.el.querySelector("[name=type]:checked")?.value || "";
            const typeFilter = currentType ? currentType.split(",") : [];

            // Filter events from pre-cached data based on date range and type
            const filteredEvents = listing.data.filter((event) => {
                // Check event type filter first
                let typeMatches = true;
                if (typeFilter.length > 0) {
                    typeMatches = typeFilter.includes(event.type);
                }

                return typeMatches;
            });

            // Group events by date using instances data
            const eventsByDate = {};
            filteredEvents.forEach((event) => {
                const instances = Object.values(event.instances || {});
                instances.forEach((instance) => {
                    const instanceDate = new Date(instance.date);
                    const startDateObj = new Date(startDate);
                    // Set end date to end of day (23:59:59.999) instead of beginning of day
                    const endDateObj = new Date(endDate);
                    endDateObj.setHours(23, 59, 59, 999);

                    if (
                        isWithinInterval(instanceDate, {
                            start: startDateObj,
                            end: endDateObj,
                        })
                    ) {
                        const dateKey = format(instanceDate, "yyyy-MM-dd");

                        if (!eventsByDate[dateKey]) {
                            eventsByDate[dateKey] = [];
                        }

                        eventsByDate[dateKey].push({
                            ...event,
                            instance: instance,
                            instanceDate: instanceDate,
                        });
                    }
                });
            });

            // Render the grouped events
            renderEventsByDate(eventsByDate, startDate, endDate, currentType);

            // Handle reset button and filter text visibility
            const activeDays = document.querySelectorAll(
                "#events-calendar-months [data-date].active",
            );
            const firstDay = document.querySelector(
                "#events-calendar-months [data-date]:not([disabled])",
            );

            if (
                activeDays.length === 1 &&
                firstDay &&
                activeDays[0] === firstDay
            ) {
                document
                    .querySelector(".date-filter-text")
                    ?.setAttribute("hidden", true);
            }

            setupResetButton(firstDay);
            listing.loading_indicator.setAttribute("active", false);
        }

        // Render events grouped by date with the same visual structure as current by-date view
        function renderEventsByDate(
            eventsByDate,
            startDate,
            endDate,
            currentType,
        ) {
            const sortedDates = Object.keys(eventsByDate).sort();

            // Create the date filter status element
            const filterText = createDateFilterText(
                startDate,
                endDate,
                currentType,
            );

            // Create the main container HTML
            let html = filterText;

            if (sortedDates.length > 0) {
                sortedDates.forEach((date) => {
                    const events = eventsByDate[date];

                    // Skip days with no events
                    if (!events || events.length === 0) {
                        return;
                    }

                    const formattedDate = format(new Date(date), "EEE d MMM");

                    // Sort events by instance time within the day
                    events.sort((a, b) => {
                        const timeA = new Date(a.instance.date);
                        const timeB = new Date(b.instance.date);
                        return timeA - timeB;
                    });

                    // Add day header
                    html += `
                        <div class="section__header">
                            <h3 class="section__heading type-h3">${formattedDate}</h3>
                        </div>
                        <ul role="list" class="listing__card-list grid">
                    `;

                    // Add event cards for this date
                    events.forEach((event) => {
                        const eventCard = createEventInstanceCard(event);

                        if (!eventCard) {
                            return;
                        }

                        html += `${eventCard}`;
                    });

                    html += "</ul>";
                });
            } else {
                // No results
                html += `
                    <div class="no-results">
                        <p class="error-text">There are no events within your selected filters,
                            try another combination</p>
                    </div>
                `;
            }

            events_by_date.innerHTML = html;
        }

        // Create the date filter text element
        function createDateFilterText(startDate, endDate, currentType) {
            const start = format(new Date(startDate), "EEE d MMM");
            const end =
                startDate === endDate
                    ? start
                    : format(new Date(endDate), "EEE d MMM");
            const dateRange =
                startDate === endDate ? start : `${start} to ${end}`;

            let title = "Shows and activities";

            if (currentType === "programme") {
                title = "Activities";
            } else if (currentType && currentType !== "") {
                title = "Shows";
            }

            return `
                <div class="date-filter-text">
                    <h2 class="listing__section-header">${title} filtered by:</h2>
                    <button class="btn btn--pill" reset-calendar>Dates: ${dateRange}</button>
                </div>
            `;
        }

        // Create an event instance card HTML from the cached data
        function createEventInstanceCard(event) {
            // Find the corresponding HTML card element from the original cards collection
            const existingCard = [...listing.cards].find(
                (card) => card.dataset.id === event.id,
            );

            if (!existingCard) {
                console.warn(`No existing card found for event ID ${event.id}`);
                return false;
            }

            // Clone the existing card and modify it for the instance
            const cardClone = existingCard.cloneNode(true);

            cardClone.setAttribute("aria-hidden", false);
            cardClone.querySelector(".card__dates").remove();

            // Find the booking button within the cloned card
            const bookingButton = cardClone.querySelector(".btn--ticket");

            if (bookingButton && event.instance) {
                // Update the booking button with instance-specific time
                const instanceTime = format(
                    new Date(event.instance.date),
                    "h.mma",
                ).replace(".00", "");

                // Get the SVG icon from the original button
                const svgIcon = bookingButton.querySelector("svg");
                const svgHTML = svgIcon ? svgIcon.outerHTML : "";

                bookingButton.innerHTML = `${svgHTML}${instanceTime}`;

                // Update the booking link with instance-specific URL
                if (event.instance.booking_url) {
                    bookingButton.href = event.instance.booking_url;
                }
            }

            return cardClone.outerHTML;
        }

        function setupResetButton(firstDay) {
            // Remove any existing event listeners to avoid duplicates
            const existingResetButton = document.querySelector(
                "button[reset-calendar]",
            );
            if (existingResetButton) {
                existingResetButton.replaceWith(
                    existingResetButton.cloneNode(true),
                );
            }

            const resetButton = document.querySelector(
                "button[reset-calendar]",
            );
            if (resetButton && firstDay) {
                resetButton.addEventListener("click", () => {
                    // Remove active class from all selected day buttons
                    document
                        .querySelectorAll(
                            "#events-calendar-months [data-date].active",
                        )
                        .forEach((el) => el.classList.remove("active"));

                    // Remove active class from all month buttons
                    document
                        .querySelectorAll("[data-select-month].active")
                        .forEach((btn) => btn.classList.remove("active"));

                    // Re-activate the first/default date
                    firstDay.classList.add("active");

                    // Hide the filter text again
                    document
                        .querySelector(".date-filter-text")
                        ?.setAttribute("hidden", true);

                    // Re-render with the first/default date
                    instances_by_date([firstDay.dataset.date]);

                    // Scroll back to the month that contains the firstDay
                    const monthEl = firstDay.closest(".events-calendar__month");
                    const calendarWrapper = document.getElementById(
                        "events-calendar-months",
                    );

                    if (monthEl && calendarWrapper) {
                        calendarWrapper.scroll({
                            top: 0,
                            left: monthEl.offsetLeft,
                            behavior: "smooth",
                        });
                    }
                });
            }
        }

        // Filters status bar
        function filters_status(filters) {
            let filtered = Object.keys(filters);

            toggle_heading_text(filters);

            // Active filters
            let active_filters = [];
            filtered.forEach((item) => {
                if (item != "type") {
                    let values = filters[item][0].split(",");

                    let key = item;
                    values.forEach((value) => {
                        let input = document.querySelector(
                            `[value="${value}"]`,
                        );
                        let button = document.createElement("button");
                        button.name = key;
                        button.classList.add("btn--pill");
                        button.dataset["value"] = value;

                        if (input.labels) {
                            button.textContent = `${item}: ${input.labels[0].textContent}`;
                        } else {
                            let label =
                                item.charAt(0).toUpperCase() + item.slice(1);
                            input = document.querySelector(
                                `[selection-name][value="${value}"]`,
                            );
                            button.textContent = `${label}: ${input.textContent}`;

                            button.addEventListener("click", (e) => {
                                let target = e.currentTarget;
                                let multi_select = document.querySelector(
                                    `cog-multi-select[name="${target.name}"]`,
                                );
                                let values = multi_select
                                    .getAttribute("value")
                                    .split(",");
                                values = values.filter(
                                    (x) => x != target.dataset.value,
                                );
                                multi_select.value = values.join(",");

                                let event = new Event("change");
                                listing.form.dispatchEvent(event);
                            });
                        }
                        active_filters.push(button);
                    });
                }
            });

            // Reset container
            status_bar_event.innerHTML = "";
            active_filters.forEach((value) => {
                status_bar_event.appendChild(value);
            });

            if (active_filters.length) {
                listing_is_filtered = true;
                let reset = reset_button.cloneNode(true);
                reset.addEventListener("click", (e) => {
                    listing.form.dispatchEvent(new Event("reset"));
                });

                status_bar_event.appendChild(reset);
                status_bar_event.setAttribute("aria-hidden", false);
            } else {
                status_bar_event.setAttribute("aria-hidden", true);
            }

            toggle_featured_blocks();
        }

        // Reset form events
        listing.form.addEventListener("reset", (e) => {
            e.preventDefault();
        
            // Reset multi-select
            document.querySelectorAll("cog-multi-select").forEach((item) => {
                item.value = "";
            });

            listing_is_filtered = false;
            toggle_featured_blocks();
            toggle_heading_text();
            // Hide filter status bar
            status_bar_event.innerHTML = "";
            status_bar_event.setAttribute("aria-hidden", true);
        });

        // Setup calendar events
        if ("undefined" === typeof calendar) {
            // Months wrapper
            let events_calendar = document.getElementById(
                "events-calendar-months",
            );
            // Months buttons, trigger scroll on click
            let months = document.querySelectorAll(
                "#events-months [data-select-month]",
            );
            months.forEach((month) => {
                month.addEventListener("click", (e) => {
                    e.preventDefault();

                    months.forEach((button) => {
                        button.classList.remove("active");
                    });

                    e.currentTarget.classList.add("active");

                    let target = e.currentTarget.dataset.selectMonth;
                    let el = document.getElementById(target);

                    if (!el) {
                        return;
                    }

                    events_calendar.scroll({
                        top: 0,
                        left: el.offsetLeft,
                        behavior: "smooth",
                    });

                    // Clear previously active days
                    document
                        .querySelectorAll("#events-calendar [data-date]")
                        .forEach((day) => {
                            day.classList.remove("active");
                        });

                    // Find all enabled day buttons within this month
                    const enabledDays = el.querySelectorAll(
                        "[data-date]:not([disabled])",
                    );

                    if (enabledDays.length) {
                        // Get the first and last available dates in this month
                        const firstDate = enabledDays[0].dataset.date;
                        const lastDate =
                            enabledDays[enabledDays.length - 1].dataset.date;

                        selected_dates = [firstDate, lastDate];

                        // Mark all days in range as active
                        enabledDays.forEach((dayBtn) => {
                            dayBtn.classList.add("active");
                        });

                        // Trigger the AJAX request
                        instances_by_date(selected_dates);
                    }
                });
            });

            // Months arrows, trigger relative scroll left or right
            let buttons = document.querySelectorAll("[data-calendar-scroll]");
            buttons.forEach((button) => {
                button.addEventListener("click", (e) => {
                    e.preventDefault();
                    const calendar_width = events_calendar.offsetWidth;
                    let scroll_by =
                        button.dataset.calendarScroll == "left"
                            ? events_calendar.scrollLeft - calendar_width
                            : events_calendar.scrollLeft + calendar_width;

                    if (button.dataset.calendarScroll == "start") {
                        scroll_by = 0;
                    }
                    events_calendar.scroll({
                        top: 0,
                        left: scroll_by,
                        behavior: "smooth",
                    });
                });
            });

            // Days, trigger ajax request
            let days = document.querySelectorAll(
                "#events-calendar [data-date]",
            );

            days.forEach((day) => {
                day.addEventListener("click", async (e) => {
                    // 🔹 Remove active highlight from month buttons when user manually clicks a day
                    document
                        .querySelectorAll("[data-select-month].active")
                        .forEach((btn) => {
                            btn.classList.remove("active");
                        });

                    let el = e.currentTarget;
                    let date = el.dataset.date;

                    if (selected_dates.length < 2) {
                        selected_dates.push(date);
                    } else {
                        selected_dates = [date];
                    }

                    selected_dates.sort();

                    if (selected_dates.length == 1) {
                        days.forEach((day) => {
                            day.classList.remove("active");
                        });
                    } else if (selected_dates.length == 2) {
                        days.forEach((day) => {
                            let in_range = isWithinInterval(day.dataset.date, {
                                start: selected_dates[0],
                                end: selected_dates[1],
                            });
                            if (in_range) {
                                day.classList.add("active");
                            }
                        });
                    }
                    el.classList.add("active");

                    instances_by_date(selected_dates);
                });
            });

            // Find available days with events and enable relevant buttons
            let requestData = {
                action: "events_calendar",
            };
            let calendar = await fetch(ajax_client.ajax_url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams(requestData).toString(),
            });
            calendar = await calendar.json();

            Object.keys(calendar).forEach((timestamp) => {
                let target = `day-${timestamp}`;
                document.getElementById(target).removeAttribute("disabled");
            });
        }

        const trigger_change = () => {
            let event = new Event("change");
            listing.form.dispatchEvent(event);
        };

        const update_history = () => {};

        document.addEventListener("cds-multi-select-selected", (e) => {
            trigger_change();
            toggle_featured_blocks();
            update_history();
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("whats-on-filters");

    if (element) {
        whatsOnListing(element);
    }
});
